import React from 'react';
import pt from 'prop-types';
import cn from 'classnames';
import { capitalize } from '@material-ui/core';
import styles from './MultiPose.module.scss';
import DisplayableSheet from './DisplayableSheet';
import {
  getNumImgsPerSheetByName,
  stripImageTypeName,
} from './functions';
import { SheetPropType } from './PropTypes';

export default function PreviewArea({ setSheets, currentSheetIndex, sheet, sheets, type, printTemplates }) {
  const nameWithoutNum = stripImageTypeName(sheet.imageType);
  const numImgsPerSheet = getNumImgsPerSheetByName(nameWithoutNum);
  const printTemplate = printTemplates?.find(template => template.id?.toString() === sheet?.imageType?.printTemplateId?.toString())

  const numToDisplay = sheet.imageType.name.toLowerCase().includes('ornament') ? numImgsPerSheet + 1 : numImgsPerSheet;

  const hasComponent = !!sheet.imageType.component;

  const renderSheetName = () => {
    if (type === 'promotion' && printTemplate?.name?.includes('Magnet')) return (
      `(${numToDisplay}) ${capitalize(nameWithoutNum.replace('sibling ', '').trim())}`
    )

    if (nameWithoutNum.includes('5x7 (2) 3x5'))
      return (
      `Sheet ${currentSheetIndex + 1} of ${sheets.length}: (1) ${capitalize(nameWithoutNum.replace('sibling ', '').trim())}`
    )

    return (
      `Sheet ${currentSheetIndex + 1} of ${sheets.length}: (${numToDisplay}) ${capitalize(nameWithoutNum.replace('sibling ', '').trim())}`
    )
  }

  return (
    <div className={cn(styles.previewArea, 'previewArea')}>
      <div className={cn(styles.innerArea, { [styles.fullWidth]: hasComponent })}>
        <DisplayableSheet inBuilder sheet={sheet} inPreview setSheets={setSheets} sheets={sheets} />
        <p className={styles.sheetHeader}>
          {renderSheetName()}
        </p>
      </div>
    </div>
  );
}

PreviewArea.propTypes = {
  currentSheetIndex: pt.number.isRequired,
  sheet: SheetPropType.isRequired,
  sheets: pt.arrayOf(SheetPropType).isRequired,
};
